export enum VariablesEnum {
    usuario_conade = 'conade-user',
    usuario = 'usuario',
    anio_informacion = 'anio_informacion'
}


export enum variablesGlobalesEnum{
    noAplica = 1
}